angular.module("psrApp.constants", [])

.constant("domains", {
	"static": "https://dkw5ssdvaqf8l.cloudfront.net",
	"http": "http://www.personare.com.br",
	"https": "https://www.personare.com.br"
})

;